import React, { useEffect, useRef, useState } from 'react';
import { PortableText } from '@portabletext/react';
import { Grid, GridItem, Flex } from '@chakra-ui/react';
import { SectionZone } from '../SectionZone';
import { components } from '../RichText/components';

export default function Section({ data, index, children }) {
  const { body, rightColumn, alignItems, singleColumn, dropCap, textCentered } = data || {};
  const rightColumnRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const checkSticky = () => {
      const windowHeight = window.innerHeight - 100;
      const rightColumnHeight = rightColumnRef?.current?.clientHeight;

      setIsSticky(rightColumnHeight < windowHeight);
    };

    checkSticky();

    window.addEventListener('resize', checkSticky);
    return () => {
      window.removeEventListener('resize', checkSticky);
    };
  }, []);

  return (
    <Grid
      gridTemplateColumns={{
        base: '1fr',
        xl: singleColumn ? '1fr' : '4fr 2fr',
      }}
      gap={{ base: 30, xl: 60 }}
      alignItems={alignItems || 'flex-start'}
      maxWidth={singleColumn ? 'container.md' : 'none'}
      mx='auto'
      textAlign={textCentered && 'center'}
    >
      <GridItem
        background='white'
        px={{ base: 30, xl: 60 }}
        pt={index === 0 && { base: 30, xl: 60 }}
        className='section'
      >
        {children}
        <Flex flexDirection='column' gap={20} className={dropCap && 'dropCap'}>
          <PortableText value={body} components={components} />
        </Flex>
      </GridItem>

      {rightColumn && (
        <GridItem
          display='flex'
          flexDirection='column'
          gap={30}
          position={isSticky ? 'sticky' : 'static'}
          top='7.1875rem'
          pr={{ base: 30, xl: 60 }}
          pl={{ base: 30, xl: 0 }}
          className='rightColumn'
          ref={rightColumnRef}
        >
          {rightColumn.map((section) => (
            <SectionZone key={section._key || section._id} section={section} side />
          ))}
        </GridItem>
      )}
    </Grid>
  );
}
